<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <van-form
      @submit="onClickButtonSubmit"
      validate-trigger="onBlur"
      @failed="handleFailed"
      ref="formRef"
    >
      <div class="kuang">
        <div class="official-document">
          <div class="official-heading">提示：</div>
          <p class="official-paragraph">
            1.
            凡涉及到填写数字、姓名等重要项目，填写第一遍后会出现弹窗提示，需再次填写确认。
          </p>
          <p class="official-paragraph">
            2.
            “手机号”仅能输入11位，“身份证号”仅能输入18位，“学校（机构）代码”仅能输入10位。均需输入两遍确认。
          </p>
          <p class="official-paragraph">
            3.
            “所学专业大类”按所授予学位证书进行选择，若没有学位证书则按毕业证书上所学专业的大类来选择。
          </p>
          <p class="official-paragraph">
            4. 本系统填报各统计项数据截止到2025年12月31日。
          </p>
        </div>
        <div style="padding: 4px 15px; font-size: 16px">
          <a
            :href="shuoming"
            download="2025年度队统填报说明.pdf"
            style="color: #ff6865; text-decoration: underline"
            >2025年度队统填报说明.pdf</a
          >
          <br />
          <a
            :href="fujian1"
            download="附件1队统填报问答.pdf"
            style="color: #ff6865; text-decoration: underline"
            >附件1队统填报问答.pdf</a
          >
          <br />

          <a
            href="https://weibo.com/tv/show/1034:5277095408894029?from=old_pc_videoshow"
            target="_blank"
            style="color: #ff6865; text-decoration: underline"
            >队统教学视频（学校使用）</a
          >
        </div>
        <!-- (一) 基本信息 -->
        <div class="section-title">（一）基本信息</div>

        <!-- 学校类型 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="学校类型"
          :rules="[{ required: true, message: '请选择学校类型' }]"
        >
          <template #input>
            <van-radio-group v-model="schoolType" direction="vertical">
              <van-radio
                v-for="item in schoolTypeList"
                :key="item.key"
                :name="item.key"
                checked-color="#ff6865"
              >
                {{ item.value }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 学校（机构）标识码 -->
        <van-field
          required
          v-model="schoolCode"
          clearable
          type="digit"
          label="学校（机构）标识码"
          placeholder="请输入10位标识码"
          maxlength="10"
          :rules="[
            { required: true, message: '请输入学校（机构）标识码' },
            {
              pattern: /^\d{10}$/,
              message: '学校（机构）标识码必须为10位数字',
            },
          ]"
          @blur="handleDoubleCheck('schoolCode', '学校（机构）标识码')"
          class="fieldVertical"
        />
        <div class="biaoshima">
          “学校(机构)标识码”是指由教育部按照国家标准及编码规则统一编制，赋予每一所学校(机构)在全国范围内唯一的、始终不变的识别标识码。不了解该代码人员请与学校办公室联系。
        </div>
        <van-field
          required
          v-model="schoolCodeConfirm"
          clearable
          type="digit"
          label="确认学校（机构）标识码"
          placeholder="请再次输入10位标识码"
          maxlength="10"
          :rules="[
            { required: true, message: '请再次填写学校（机构）标识码' },
            { pattern: /^\d{10}$/, message: '标识码必须为10位数字' },
            {
              validator: (val) => val === schoolCode,
              message: '两次输入的学校（机构）标识码不一致',
            },
          ]"
          class="fieldVertical"
        />

        <!-- 所处区域 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="所处区域"
          :rules="[{ required: true, message: '请选择所处区域' }]"
        >
          <template #input>
            <van-radio-group v-model="location" direction="horizontal">
              <van-radio
                v-for="item in schoolAreaList"
                :key="item.key"
                :name="item.key"
                checked-color="#ff6865"
              >
                {{ item.value }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- (二) 少先队组织信息 -->
        <div class="section-title">（二）少先队组织信息</div>

        <!-- 中队数量 -->
        <van-field
          required
          v-model="squadronNum"
          clearable
          type="digit"
          label="中队数量"
          placeholder="请输入中队数量"
          :rules="[
            { required: true, message: '请输入中队数量' },
            { validator: validateSquadronNum, label: '中队数量' },
          ]"
          @blur="handleCountCheck('squadronNum', '中队数量')"
          class="fieldVertical"
        />
        <van-field
          required
          v-model="squadronNumConfirm"
          clearable
          type="digit"
          label="确认中队数量"
          placeholder="请再次输入中队数量"
          :rules="[
            { required: true, message: '请再次输入中队数量' },
            {
              validator: (val) => val === squadronNum,
              message: '两次输入的中队数量不一致',
            },
            { validator: validateSquadronNum, label: '确认中队数量' },
          ]"
          class="fieldVertical"
        />

        <!-- 少先队员人数 -->
        <van-field
          required
          v-model="youngPioneersNum"
          clearable
          type="digit"
          label="少先队员人数"
          placeholder="请输入少先队员人数"
          :rules="[
            { required: true, message: '请输入少先队员人数' },
            { validator: validateYoungPioneersNum, label: '少先队员人数' },
          ]"
          @blur="handleCountCheck('youngPioneersNum', '少先队员人数')"
          class="fieldVertical"
        />
        <van-field
          required
          v-model="youngPioneersNumConfirm"
          clearable
          type="digit"
          label="确认少先队员人数"
          placeholder="请再次输入少先队员人数"
          :rules="[
            { required: true, message: '请再次输入少先队员人数' },
            {
              validator: (val) => val === youngPioneersNum,
              message: '两次输入的少先队员数不一致',
            },
            { validator: validateYoungPioneersNum, label: '确认少先队员人数' },
          ]"
          class="fieldVertical"
        />

        <!-- 本校x-x年级学生数 -->
        <van-field
          required
          v-model="studentNum"
          clearable
          type="digit"
          :label="studentNumLabel"
          placeholder="请输入本校学生数"
          :rules="[
            { required: true, message: '请输入本校学生数' },
            { validator: validateStudentNum, label: studentNumLabel },
          ]"
          @blur="handleCountCheck('studentNum', studentNumLabel)"
          class="fieldVertical"
        />
        <van-field
          required
          v-model="studentNumConfirm"
          clearable
          type="digit"
          :label="'确认' + studentNumLabel"
          placeholder="请再次输入本校学生数"
          :rules="[
            { required: true, message: '请再次输入本校学生数' },
            {
              validator: (val) => val === studentNum,
              message: '本校学生两次输入的人数不一致',
            },
            { validator: validateStudentNum, label: '确认' + studentNumLabel },
          ]"
          class="fieldVertical"
        />

        <!-- 最近一次少代会召开时间 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="最近一次少代会召开时间（近十年）"
          :rules="[
            {
              required: true,
              message: '请选择最近一次少代会召开时间（近十年）',
            },
          ]"
        >
          <template #input>
            <van-radio-group v-model="congressType" direction="horizontal">
              <van-radio :name="1" checked-color="#ff6865">年/月</van-radio>
              <van-radio :name="2" checked-color="#ff6865">未开过</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <date-picker
          v-if="congressType == 1"
          :value="lastCongressTime"
          title="选择时间"
          type="year-month"
          :callback="(val) => handlerSelect('lastCongressTime', val)"
          :isRequired="lastCongressTimeFlag"
          minDate="2014-01"
        />

        <!-- 学校学生分几批次入队 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="学校学生分几批次入队"
          :rules="[{ required: true, message: '请选择学校学生分几批次入队' }]"
          v-if="schoolType != 2 && schoolType != 5"
        >
          <template #input>
            <van-radio-group v-model="batchEntry" direction="vertical">
              <van-radio
                v-for="item in ruduiPiciList"
                :key="item.key"
                :name="item.key"
                checked-color="#ff6865"
              >
                {{ item.value }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 学校开展“红领巾奖章”争章活动情况 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="学校是否开展“红领巾奖章”争章活动"
          :rules="[
            {
              required: true,
              message: '请选择学校是否开展“红领巾奖章”争章活动',
            },
          ]"
        >
          <template #input>
            <van-radio-group v-model="hasRedScarfBadge" direction="horizontal">
              <van-radio :name="1" checked-color="#ff6865">是</van-radio>
              <van-radio :name="2" checked-color="#ff6865">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 学校是否开展“红领巾讲解员”活动 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="学校是否开展“红领巾讲解员”活动"
          :rules="[
            {
              required: true,
              message: '请选择学校是否开展“红领巾讲解员”活动',
            },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="hasRedScarfExplainer"
              direction="horizontal"
            >
              <van-radio :name="1" checked-color="#ff6865">是</van-radio>
              <van-radio :name="2" checked-color="#ff6865">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 学校是否开展“少年军校”活动 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="学校是否开展“少年军校”活动"
          :rules="[
            {
              required: true,
              message: '请选择学校是否开展“少年军校”活动',
            },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="hasYoungMilitarySchool"
              direction="horizontal"
            >
              <van-radio :name="1" checked-color="#ff6865">是</van-radio>
              <van-radio :name="2" checked-color="#ff6865">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 学生入队时首次佩戴的红领巾是否由学校配发 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="学生入队时首次佩戴的红领巾是否由学校配发"
          :rules="[
            {
              required: true,
              message: '请选择学生入队时首次佩戴的红领巾是否由学校配发',
            },
          ]"
          v-if="schoolType != 2 && schoolType != 5"
        >
          <template #input>
            <van-radio-group
              v-model="isRedScarfDistributed"
              direction="horizontal"
            >
              <van-radio :name="1" checked-color="#ff6865">是</van-radio>
              <van-radio :name="2" checked-color="#ff6865">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 是否有少先队队室 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="是否有少先队队室"
          :rules="[{ required: true, message: '请选择是否有少先队队室' }]"
        >
          <template #input>
            <van-radio-group
              v-model="hasYoungPioneersRoom"
              direction="horizontal"
            >
              <van-radio :name="1" checked-color="#ff6865">是</van-radio>
              <van-radio :name="2" checked-color="#ff6865">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="hasYoungPioneersRoom == 1"
          class="fieldVertical"
          required
          name="radio"
          label="少先队队室面积"
          :rules="[{ required: true, message: '请选择少先队队室面积' }]"
        >
          <template #input>
            <van-radio-group v-model="roomSize" direction="vertical">
              <van-radio
                v-for="item in sxdClassMList"
                :key="item.key"
                :name="item.key"
                checked-color="#ff6865"
              >
                {{ item.value }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 是否有少先队鼓号队 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="是否有少先队鼓号队"
          :rules="[{ required: true, message: '请选择是否有少先队鼓号队' }]"
        >
          <template #input>
            <van-radio-group v-model="hasDrumBugleCorps" direction="horizontal">
              <van-radio :name="1" checked-color="#ff6865">是</van-radio>
              <van-radio :name="2" checked-color="#ff6865">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div v-if="hasDrumBugleCorps == 1">
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="少先队鼓号队编制"
            :rules="[{ required: true, message: '请选择少先队鼓号队编制' }]"
          >
            <template #input>
              <van-radio-group v-model="corpsSize" direction="vertical">
                <van-radio
                  v-for="item in sxdGhdPopList"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div class="tip-text">
            *根据《中国少年先锋队鼓号队建设标准（试行）》规定，大型鼓号队编制66人，中型鼓号队编制33人，小型鼓号队编制17人。
          </div>
        </div>

        <!-- 少先队活动课课时安排情况 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="少先队活动课课时安排情况"
          :rules="[
            { required: true, message: '请选择少先队活动课课时安排情况' },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="activityClassSchedule"
              direction="vertical"
            >
              <van-radio
                v-for="item in sxdHdkList"
                :key="item.key"
                :name="item.key"
                checked-color="#ff6865"
              >
                {{ item.value }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 2025年度本校中队辅导员参加少先队线下相关培训的人数 -->
        <van-field
          required
          v-model="offlineTrainingNum"
          clearable
          type="digit"
          label="2025年度本校中队辅导员参加少先队线下相关培训的人数"
          placeholder="请输入2025年度本校中队辅导员参加少先队线下相关培训的人数"
          :rules="[
            {
              required: true,
              message:
                '请输入2025年度本校中队辅导员参加少先队线下相关培训的人数',
            },
            {
              validator: validateMax200,
              label: '2025年度本校中队辅导员参加少先队线下相关培训的人数',
            },
          ]"
          @blur="
            handleCountCheck(
              'offlineTrainingNum',
              '2025年度本校中队辅导员参加少先队线下相关培训的人数'
            )
          "
          class="fieldVertical"
        />
        <van-field
          required
          v-model="offlineTrainingNumConfirm"
          clearable
          type="digit"
          label="确认培训人数"
          placeholder="请再次输入培训人数"
          :rules="[
            { required: true, message: '请再次输入培训人数' },
            {
              validator: (val) => val === offlineTrainingNum,
              message: '两次输入的培训人数不一致',
            },
            { validator: validateMax200, label: '确认培训人数' },
          ]"
          class="fieldVertical"
        />

        <!-- (三) 学校少工委主任信息 -->
        <div class="section-title">（三）学校少工委主任信息</div>

        <!-- 学校少工委主任职务 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          :rules="[{ required: true, message: '请选择学校少工委主任职务' }]"
        >
          <template #label>
            学校少工委主任由<span style="text-decoration: underline"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >来担任
          </template>
          <template #input>
            <van-radio-group v-model="directorPosition" direction="vertical">
              <van-radio
                v-for="item in sgwZhuRenList1"
                :key="item.key"
                :name="item.key"
                checked-color="#ff6865"
              >
                {{ item.value }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 学校少工委主任姓名 -->
        <!-- @blur="handleDoubleCheck('directorName', '学校少工委主任姓名')" -->
        <template v-if="directorPosition < 6">
          <van-field
            required
            v-model="directorName"
            clearable
            label="学校少工委主任姓名"
            placeholder="请输入学校少工委主任姓名"
            :rules="[
              { required: true, message: '请输入学校少工委主任姓名' },
              { validator: validateName, label: '学校少工委主任姓名' },
            ]"
            class="fieldVertical"
          />
          <van-field
            required
            v-model="directorNameConfirm"
            clearable
            label="确认学校少工委主任姓名"
            placeholder="请再次输入学校少工委主任姓名"
            :rules="[
              { required: true, message: '请再次输入学校少工委主任姓名' },
              {
                validator: (val) => val === directorName,
                message: '两次输入的学校少工委主任姓名不一致',
              },
              { validator: validateName, label: '确认学校少工委主任姓名' },
            ]"
            class="fieldVertical"
          />

          <!-- 政治面貌 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="政治面貌"
            :rules="[
              { required: true, message: '请选择学校少工委主任政治面貌' },
            ]"
          >
            <template #input>
              <van-radio-group
                v-model="directorPoliticalStatus"
                direction="vertical"
              >
                <van-radio
                  v-for="item in zzmmList02"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 手机号 -->
          <van-field
            required
            v-model="directorTel"
            clearable
            label="学校少工委主任手机号"
            placeholder="请输入11位手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请输入学校少工委主任手机号' },
              { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误' },
            ]"
            @blur="handleDoubleCheck('directorTel', '学校少工委主任手机号')"
            class="fieldVertical"
          />
          <van-field
            required
            v-model="directorTelConfirm"
            clearable
            label="确认学校少工委主任手机号"
            placeholder="请再次输入手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请再次输入手机号' },
              {
                validator: (val) => val === directorTel,
                message: '两次输入的手机号不一致',
              },
            ]"
            class="fieldVertical"
          />
        </template>
        <!-- (四) 大队辅导员信息 -->
        <div class="section-title">（四）大队辅导员信息</div>

        <!-- 身份类型 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="在本填报年度，负责学校少先队工作的人员身份类型"
          :rules="[
            {
              required: true,
              message: '请选择负责学校少先队工作的人员身份类型',
            },
          ]"
        >
          <template #input>
            <van-radio-group v-model="personnelStatus" direction="vertical">
              <van-radio :name="1" checked-color="#ff6865"
                >大队辅导员</van-radio
              >
              <van-radio :name="2" checked-color="#ff6865"
                >未配备大队辅导员</van-radio
              >
            </van-radio-group>
          </template>
        </van-field>

        <!-- 未配备大队辅导员时的子选项 -->
        <van-field
          v-if="personnelStatus == 2"
          class="fieldVertical"
          required
          name="radio"
          label="具体身份"
          :rules="[{ required: true, message: '请选择具体身份' }]"
        >
          <template #input>
            <van-radio-group v-model="subPersonnelStatus" direction="vertical">
              <van-radio :name="2" checked-color="#ff6865"
                >副大队辅导员</van-radio
              >
              <van-radio :name="3" checked-color="#ff6865"
                >代履行大队辅导员职责的其他人员</van-radio
              >
            </van-radio-group>
          </template>
        </van-field>

        <!-- 大队辅导员详细信息 - 当personnelStatus == 1时显示 -->
        <div v-if="personnelStatus == 1">
          <!-- 姓名 -->
          <!-- @blur="handleDoubleCheck('name', '姓名')" -->
          <van-field
            required
            v-model="name"
            clearable
            label="大队辅导员姓名"
            placeholder="请输入大队辅导员姓名"
            :rules="[
              { required: true, message: '请输入大队辅导员姓名' },
              { validator: validateName, label: '大队辅导员姓名' },
            ]"
            class="fieldVertical"
          />
          <van-field
            required
            v-model="nameConfirm"
            clearable
            label="确认大队辅导员姓名"
            placeholder="请再次输入大队辅导员姓名"
            :rules="[
              { required: true, message: '请再次输入大队辅导员姓名' },
              {
                validator: (val) => val === name,
                message: '两次输入的大队辅导员姓名不一致',
              },
              { validator: validateName, label: '确认大队辅导员姓名' },
            ]"
            class="fieldVertical"
          />

          <!-- 上传聘书 -->
          <van-field
            class="fieldVertical"
            name="uploader"
            label="上传大队辅导员本人聘书或任命文件的图片"
            required
            :rules="[
              {
                required: true,
                message: '请上传大队辅导员本人聘书或任命文件的图片',
              },
            ]"
          >
            <template #input>
              <van-uploader
                v-model="fileList"
                :max-count="1"
                :after-read="afterRead"
                @click-preview="handlePreview"
              />
            </template>
          </van-field>
          <div class="tip-text">
            聘书或任命文件的图片应为PNG或JPG格式，尺寸不低于1024*768，公章清晰、内容完整。无上述文件的由所在学校或县区的共青团、教育行政部门、少工委开具证明均可，
            <a
              :href="proofFile"
              download="证明模板.docx"
              style="color: #ff6865; text-decoration: underline"
              >证明模板</a
            >
          </div>

          <!-- 身份证号 -->
          <van-field
            required
            v-model="idCard"
            clearable
            label="大队辅导员身份证号"
            placeholder="请输入18位身份证号"
            maxlength="18"
            :rules="[
              { required: true, message: '请输入大队辅导员身份证号' },
              {
                pattern:
                  /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                message: '大队辅导员身份证号格式错误',
              },
            ]"
            @blur="handleDoubleCheck('idCard', '大队辅导员身份证号')"
            class="fieldVertical"
          />
          <van-field
            required
            v-model="idCardConfirm"
            clearable
            label="确认大队辅导员身份证号"
            placeholder="请再次输入大队辅导员身份证号"
            maxlength="18"
            :rules="[
              { required: true, message: '请再次输入大队辅导员身份证号' },
              {
                validator: (val) => val === idCard,
                message: '两次输入的大队辅导员身份证号不一致',
              },
            ]"
            class="fieldVertical"
          />

          <!-- 性别 -->
          <van-field
            required
            name="radio"
            label="性别"
            class="radioFlex"
            :rules="[{ required: true, message: '请选择性别' }]"
          >
            <template #input>
              <van-radio-group v-model="sex" direction="horizontal">
                <van-radio :name="1" checked-color="#ff6865">男</van-radio>
                <van-radio :name="2" checked-color="#ff6865">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 年龄 -->
          <van-field
            :model-value="age ? age + '岁' : ''"
            readonly
            label="年龄"
            placeholder="根据身份证号自动生成"
          />

          <!-- 政治面貌 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="政治面貌"
            :rules="[{ required: true, message: '请选择政治面貌' }]"
          >
            <template #input>
              <van-radio-group v-model="politicalStatus" direction="vertical">
                <van-radio
                  v-for="item in zzmmList02"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 手机号 -->
          <van-field
            required
            v-model="tel"
            clearable
            label="大队辅导员手机号"
            placeholder="请输入11位大队辅导员手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请输入大队辅导员手机号' },
              {
                pattern: /^1[3456789]\d{9}$/,
                message: '大队辅导员手机号格式错误',
              },
            ]"
            @blur="handleDoubleCheck('tel', '大队辅导员手机号')"
            class="fieldVertical"
          />
          <van-field
            required
            v-model="telConfirm"
            clearable
            label="确认大队辅导员手机号"
            placeholder="请再次输入大队辅导员手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请再次输入大队辅导员手机号' },
              {
                validator: (val) => val === tel,
                message: '两次输入的大队辅导员手机号不一致',
              },
            ]"
            class="fieldVertical"
          />

          <!-- 是否师范生 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="是否师范生"
            :rules="[{ required: true, message: '请选择是否师范生' }]"
          >
            <template #input>
              <van-radio-group v-model="isNormalStudent" direction="horizontal">
                <van-radio :name="1" checked-color="#ff6865">是</van-radio>
                <van-radio :name="2" checked-color="#ff6865">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 全日制教育学历 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="全日制教育学历"
            :rules="[{ required: true, message: '请选择学历' }]"
          >
            <template #input>
              <van-radio-group v-model="fullTimeEdu" direction="vertical">
                <van-radio
                  v-for="item in eduList01"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 所学专业大类 -->
          <diy-picker
            label="请选择"
            title="所学专业大类(全日制)"
            :value="fullTimeMajorTxt"
            :list="majorList"
            :handlerSelect="selectFullTimeMajor"
            :isClick="true"
            :isRequired="fullTimeMajorFlag"
          />
          <div class="tip-text">
            *按所授予学位证书进行选择，若没有学位证书则按毕业证书上所学专业的大类来选择。
          </div>

          <!-- 继续教育学历 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="继续教育学历"
            :rules="[{ required: true, message: '请选择学历' }]"
          >
            <template #input>
              <van-radio-group v-model="continueEdu" direction="vertical">
                <van-radio :name="0" checked-color="#ff6865">未参加</van-radio>
                <van-radio
                  v-for="item in eduList01"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 所学专业大类 -->
          <div v-if="continueEdu !== 0 && continueEdu !== null">
            <diy-picker
              label="请选择"
              title="所学专业大类(继续教育)"
              :value="continueMajorTxt"
              :list="majorList"
              :handlerSelect="selectContinueMajor"
              :isClick="true"
              :isRequired="continueMajorFlag"
            />
          </div>
        </div>

        <!-- 6-1, 6-2, 6-3, 7, 8, 9, 10 -->
        <div v-if="personnelStatus != 0">
          <!-- 学校是否成立团组织 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="学校是否成立团组织"
            :rules="[{ required: true, message: '请选择学校是否成立团组织' }]"
          >
            <template #input>
              <van-radio-group v-model="hasLeagueOrg" direction="horizontal">
                <van-radio :name="1" checked-color="#ff6865">是</van-radio>
                <van-radio :name="2" checked-color="#ff6865">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 是否兼任校内团干部职务 -->
          <div v-if="hasLeagueOrg == 1 && personnelStatus == 1">
            <van-field
              class="fieldVertical"
              required
              name="radio"
              label="是否兼任校内团干部职务"
              :rules="[{ required: true, message: '请选择' }]"
            >
              <template #input>
                <van-radio-group v-model="isLeagueCadre" direction="horizontal">
                  <van-radio :name="1" checked-color="#ff6865">是</van-radio>
                  <van-radio :name="2" checked-color="#ff6865">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <!-- 兼任校内团干部职务 -->
            <van-field
              v-if="isLeagueCadre == 1 && personnelStatus == 1"
              class="fieldVertical"
              required
              name="radio"
              label="兼任校内团干部职务"
              :rules="[{ required: true, message: '请选择职务' }]"
            >
              <template #input>
                <van-radio-group v-model="leaguePosition" direction="vertical">
                  <van-radio
                    v-for="item in haveTuanJobMajorList"
                    :key="item.key"
                    :name="item.key"
                    checked-color="#ff6865"
                  >
                    {{ item.value }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>

          <!-- 大队辅导员专属项 (仅在personnelStatus == 1时显示) -->
          <div v-if="personnelStatus == 1">
            <!-- 任本校大队辅导员开始时间 -->
            <date-picker
              :value="startTime"
              title="任本校大队辅导员开始时间"
              label="请选择"
              type="year-month"
              :callback="(val) => handlerSelect('startTime', val)"
              :isRequired="startTimeFlag"
              minDate="1980-01"
            />

            <!-- 累计从事少先队工作年限 -->
            <van-field
              required
              v-model="workYears"
              clearable
              type="number"
              label="累计从事少先队工作年限"
              placeholder="请输入年限(精确到0.5年)"
              :rules="[
                { required: true, message: '请输入累计从事少先队工作年限' },
                {
                  validator: validateWorkYears,
                  label: '累计从事少先队工作年限',
                },
              ]"
              @blur="handleCountCheck('workYears', '累计从事少先队工作年限')"
              class="fieldVertical"
            />
            <!-- <div class="tip-text">
              如果任本校大队辅导员开始时间到填报时不足半年的，按半年计算，填0.5。
            </div> -->
            <van-field
              required
              v-model="workYearsConfirm"
              clearable
              type="number"
              label="确认累计从事少先队工作年限"
              placeholder="请再次输入确认累计年限"
              :rules="[
                { required: true, message: '请再次输入确认累计年限' },
                {
                  validator: (val) => val === workYears,
                  message: '两次输入的累计从事少先队工作年限不一致',
                },
                {
                  validator: validateWorkYears,
                  label: '确认累计从事少先队工作年限',
                },
              ]"
              class="fieldVertical"
            />

            <!-- 是否有担任中队辅导员的经历 -->
            <van-field
              class="fieldVertical"
              required
              name="radio"
              label="是否有担任中队辅导员的经历"
              :rules="[{ required: true, message: '请选择' }]"
            >
              <template #input>
                <van-radio-group
                  v-model="hasSquadronExp"
                  direction="horizontal"
                >
                  <van-radio :name="1" checked-color="#ff6865">是</van-radio>
                  <van-radio :name="2" checked-color="#ff6865">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <!-- 担任中队辅导员累计年限 -->
            <div v-if="hasSquadronExp == 1">
              <van-field
                required
                v-model="squadronWorkYears"
                clearable
                type="number"
                label="担任中队辅导员累计年限"
                placeholder="请输入年限(精确到0.5年)"
                :rules="[
                  { required: true, message: '请输入担任中队辅导员累计年限' },
                  {
                    validator: validateSquadronWorkYears,
                    label: '担任中队辅导员累计年限',
                  },
                ]"
                @blur="
                  handleCountCheck(
                    'squadronWorkYears',
                    '担任中队辅导员累计年限'
                  )
                "
                class="fieldVertical"
              />
              <van-field
                required
                v-model="squadronWorkYearsConfirm"
                clearable
                type="number"
                label="确认累计年限"
                placeholder="请再次输入年限"
                :rules="[
                  { required: true, message: '请再次输入年限' },
                  {
                    validator: (val) => val === squadronWorkYears,
                    message: '两次输入的年限不一致',
                  },
                  {
                    validator: validateSquadronWorkYears,
                    label: '确认累计年限',
                  },
                ]"
                class="fieldVertical"
              />
            </div>

            <!-- 校内职务 -->
            <van-field
              class="fieldVertical"
              required
              name="radio"
              label="校内职务"
              :rules="[{ required: true, message: '请选择职务' }]"
            >
              <template #input>
                <van-radio-group v-model="schoolPosition" direction="vertical">
                  <van-radio
                    v-for="item in schoolMajorList"
                    :key="item.key"
                    :name="item.key"
                    checked-color="#ff6865"
                  >
                    {{ item.value }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <!-- 享受待遇 -->
            <van-field
              v-if="[4, 5, 6].includes(schoolPosition)"
              class="fieldVertical"
              required
              name="radio"
              label="享受待遇"
              :rules="[{ required: true, message: '请选择待遇' }]"
            >
              <template #input>
                <van-radio-group v-model="treatmentRank" direction="vertical">
                  <van-radio
                    v-for="item in salaryList"
                    :key="item.key"
                    :name="item.key"
                    checked-color="#ff6865"
                  >
                    {{ item.value }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <!-- 职称 -->
            <van-field
              class="fieldVertical"
              required
              name="radio"
              label="职称"
              :rules="[{ required: true, message: '请选择职称' }]"
            >
              <template #input>
                <van-radio-group
                  v-model="professionalTitle"
                  direction="vertical"
                >
                  <van-radio
                    v-for="item in jobTitleList"
                    :key="item.key"
                    :name="item.key"
                    checked-color="#ff6865"
                  >
                    {{ item.value }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <!-- 任教学科门数 -->
            <van-field
              class="fieldVertical"
              required
              name="radio"
              label="任教学科门数"
              :rules="[{ required: true, message: '请选择门数' }]"
            >
              <template #input>
                <van-radio-group v-model="subjectNum" direction="vertical">
                  <van-radio
                    v-for="item in teachSubjectNumList"
                    :key="item.key"
                    :name="item.key"
                    checked-color="#ff6865"
                  >
                    {{ item.value }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <!-- 任教学科 -->
            <div v-if="subjectNum > 1">
              <van-field
                class="fieldVertical"
                required
                name="checkboxGroup"
                label="任教学科"
                :rules="[
                  { required: true, message: '请选择任教学科' },
                  {
                    validator: validateSubjectCount,
                    message: '选择学科数量需与任教学科门数一致',
                  },
                ]"
              >
                <template #input>
                  <van-checkbox-group v-model="subjects" direction="vertical">
                    <van-checkbox
                      v-for="item in teachSubjectsList"
                      :key="item.key"
                      :name="item.key"
                      shape="square"
                      checked-color="#ff6865"
                    >
                      {{ item.value }}
                    </van-checkbox>
                  </van-checkbox-group>
                </template>
              </van-field>
              <van-field
                v-if="subjects.includes(10)"
                required
                v-model="subjectsOther"
                label="具体学科名称"
                placeholder="请输入具体学科名称"
                :rules="[{ required: true, message: '请输入具体学科名称' }]"
              />
            </div>

            <!-- 每周课时数 -->
            <van-field
              required
              v-model="weeklyHours"
              clearable
              type="digit"
              label="每周课时数"
              placeholder="请输入课时数，无教学任务的须填0"
              :rules="[
                { required: true, message: '请输入每周课时数' },
                { validator: validateWeeklyHours },
              ]"
              @blur="handleCountCheck('weeklyHours', '每周课时数', 30)"
              class="fieldVertical"
            />
            <van-field
              required
              v-model="weeklyHoursConfirm"
              clearable
              type="digit"
              label="确认每周课时数"
              placeholder="请再次输入课时数，无教学任务的须填0"
              :rules="[
                { required: true, message: '请再次输入每周课时数' },
                {
                  validator: (val) => val === weeklyHours,
                  message: '两次输入的每周课时数不一致',
                },
                { validator: validateWeeklyHours },
              ]"
              class="fieldVertical"
            />
          </div>

          <!-- 副大队辅导员人数 -->
          <van-field
            required
            v-model="deputyCounselorNum"
            clearable
            type="digit"
            label="本校除正式大队辅导员以外，设有副大队辅导员人数"
            placeholder="请输入人数(未设的须填填0)"
            :rules="[
              {
                required: true,
                message: '请输入本校除正式大队辅导员以外，设有副大队辅导员人数',
              },
              { validator: validateMax20, label: '副大队辅导员人数' },
            ]"
            @blur="
              handleCountCheck(
                'deputyCounselorNum',
                '本校除正式大队辅导员以外，设有副大队辅导员人数',
                20
              )
            "
            class="fieldVertical"
          />
          <div style="font-size: 12px; color: #999; padding: 0 16px 10px">
            分校区大队辅导员，分设中学部、小学部的大队辅导员等均纳入本次副大队辅导员人数统计。未设的须填“0”
          </div>
          <van-field
            required
            v-model="deputyCounselorNumConfirm"
            clearable
            type="digit"
            label="确认副大队辅导员人数"
            placeholder="请再次确认副大队辅导员人数"
            :rules="[
              { required: true, message: '请输人确认副大队辅导员人数' },
              {
                validator: (val) => val === deputyCounselorNum,
                message: '两次输入的副大队辅导员人数不一致',
              },
              { validator: validateMax20, label: '确认副大队辅导员人数' },
            ]"
            class="fieldVertical"
          />

          <!-- (五) 填表人信息 -->
          <div class="section-title-1">填表人信息</div>

          <!-- 填表人姓名 -->
          <!-- @blur="handleDoubleCheck('fillerName', '填表人姓名')" -->
          <van-field
            required
            v-model="fillerName"
            clearable
            label="填表人姓名"
            placeholder="请输入姓名"
            :rules="[
              { required: true, message: '请输入填表人姓名' },
              { validator: validateName, label: '填表人姓名' },
            ]"
            class="fieldVertical"
          />
          <van-field
            required
            v-model="fillerNameConfirm"
            clearable
            label="确认填表人姓名"
            placeholder="请再次输入姓名"
            :rules="[
              { required: true, message: '请再次输入填表人姓名' },
              {
                validator: (val) => val === fillerName,
                message: '两次输入的填表人姓名不一致',
              },
              { validator: validateName, label: '确认填表人姓名' },
            ]"
            class="fieldVertical"
          />

          <!-- 填表人手机号 -->
          <van-field
            required
            v-model="fillerTel"
            clearable
            label="填表人手机号"
            placeholder="请输入11位手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请输入填表人手机号' },
              { pattern: /^1[3456789]\d{9}$/, message: '填表人手机号格式错误' },
            ]"
            @blur="handleDoubleCheck('fillerTel', '填表人手机号')"
            class="fieldVertical"
          />
          <van-field
            required
            v-model="fillerTelConfirm"
            clearable
            label="确认填表人手机号"
            placeholder="请再次输入填表人手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请再次输入填表人手机号' },
              {
                validator: (val) => val === fillerTel,
                message: '两次输入的填表人手机号不一致',
              },
            ]"
            class="fieldVertical"
          />

          <!-- 填表人工作单位及职务 -->
          <van-field
            required
            v-model="fillerUnitJob"
            clearable
            label="填表人工作单位及职务"
            placeholder="请输入填表人工作单位及职务"
            :rules="[{ required: true, message: '请输入填表人工作单位及职务' }]"
            class="fieldVertical"
          />
        </div>
      </div>

      <div style="margin: 16px">
        <van-button
          round
          block
          type="primary"
          native-type="submit"
          class="btn btn_dl"
          :loading="isSubmitting"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { ref, reactive, toRefs, computed, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Toast, Dialog, Uploader, ImagePreview } from "vant";
import headers from "@/components/Header";
import DatePicker from "@/components/DatePicker";
import diyPicker from "@/components/Select";
import {
  schoolTypeList,
  schoolAreaList,
  ruduiPiciList,
  sxdClassMList,
  sxdGhdPopList,
  sxdHdkList,
  sgwZhuRenList1,
  zzmmList02,
  eduList01,
  majorList,
  haveTuanJobMajorList,
  schoolMajorList,
  salaryList,
  jobTitleList,
  teachSubjectNumList,
  teachSubjectsList,
} from "@/common/js/field";
import { addForm, editForm, getsubmitData } from "@/service/form";
import {
  getKey,
  encrypt,
  rsaUtil,
  serverPublicKey,
  tipsMsg,
} from "@/common/js";
export default {
  name: "Form12",
  components: {
    headers,
    DatePicker,
    diyPicker,
    [Uploader.name]: Uploader,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const formRef = ref(null);
    const isSubmitting = ref(false); // 状态锁

    const state = reactive({
      // (一) 基本信息
      schoolType: null,
      schoolCode: "",
      schoolCodeConfirm: "",
      location: null,

      // (二) 少先队组织信息
      squadronNum: "",
      squadronNumConfirm: "",
      youngPioneersNum: "",
      youngPioneersNumConfirm: "",
      studentNum: "",
      studentNumConfirm: "",
      congressType: null,
      lastCongressTime: "",
      lastCongressTimeFlag: false,
      batchEntry: null,
      hasRedScarfBadge: null,
      hasRedScarfExplainer: null,
      hasYoungMilitarySchool: null,
      isRedScarfDistributed: null,
      hasYoungPioneersRoom: null,
      roomSize: null,
      hasDrumBugleCorps: null,
      corpsSize: null,
      activityClassSchedule: null,
      offlineTrainingNum: "",
      offlineTrainingNumConfirm: "",

      // (三) 学校少工委主任信息
      directorPosition: null,
      directorName: "",
      directorNameConfirm: "",
      directorPoliticalStatus: null,
      directorTel: "",
      directorTelConfirm: "",

      // (四) 大队辅导员信息
      personnelStatus: null, // 默认为大队辅导员
      subPersonnelStatus: null,
      name: "",
      nameConfirm: "",
      fileList: [],
      file: "",
      idCard: "",
      idCardConfirm: "",
      sex: null,
      age: "",
      birthday: "",
      birthdayFlag: false,
      politicalStatus: null,
      tel: "",
      telConfirm: "",
      isNormalStudent: null,
      fullTimeEdu: null,
      fullTimeMajor: null,
      fullTimeMajorTxt: "",
      fullTimeMajorFlag: false,
      continueEdu: null,
      continueMajor: null,
      continueMajorTxt: "",
      continueMajorFlag: false,
      hasLeagueOrg: null,
      isLeagueCadre: null,
      leaguePosition: null,
      startTime: "",
      startTimeFlag: false,
      workYears: "",
      workYearsConfirm: "",
      hasSquadronExp: null,
      squadronWorkYears: "",
      squadronWorkYearsConfirm: "",
      schoolPosition: null,
      treatmentRank: null,
      professionalTitle: null,
      subjectNum: null,
      subjects: [],
      subjectsOther: "",
      weeklyHours: "",
      weeklyHoursConfirm: "",

      // 9. 副大队辅导员人数
      deputyCounselorNum: "",
      deputyCounselorNumConfirm: "",

      // (五) 填表人信息
      fillerName: "",
      fillerNameConfirm: "",
      fillerTel: "",
      fillerTelConfirm: "",
      fillerUnitJob: "",

      // 辅助状态
      confirmedFields: new Set(),
      proofFile: "/file/proof.docx",
      shuoming: "/file/2025年度队统填报说明.pdf",
      fujian1: "/file/附件1队统填报问答.pdf",
      fujian2: "/file/附件2队统后台使用手册.pdf",
    });

    const studentNumLabel = computed(() => {
      if (state.schoolType === 1) return "本校1-6年级学生数";
      if ([2, 5].includes(state.schoolType)) return "本校7-9年级学生数";
      if ([3, 4].includes(state.schoolType)) return "本校1-9年级学生数";
      return "本校学生数";
    });

    const handleDoubleCheck = (field, label) => {
      //  && !state.confirmedFields.has(field)
      if (state[field]) {
        Dialog.alert({
          title: "提示",
          message: `您填写的${label}为：${state[field]}，请在下方再次输入以确认。`,
        }).then(() => {
          state.confirmedFields.add(field);
        });
      }
    };

    const handleCountCheck = (field, label, limit = null) => {
      //   && !state.confirmedFields.has(field)
      if (state[field]) {
        let msg = `您填写的${label}为：${state[field]}，请在下方再次输入以确认。`;
        if (limit && Number(state[field]) > limit) {
          msg = `警示：您填写的${label}为：${state[field]}，数值超过了${limit}，请核实并再次输入以确认。`;
        }
        Dialog.alert({
          title: "提示",
          message: msg,
        }).then(() => {
          state.confirmedFields.add(field);
        });
      }
    };

    const handlerSelect = (field, val) => {
      state[field] = val;
      if (
        field === "birthday" &&
        state.idCard &&
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          state.idCard
        )
      ) {
        const idBirthday = state.idCard.substring(6, 12); // YYYYMM
        const selectedDate = new Date(val * 1000);
        const year = selectedDate.getFullYear();
        let month = selectedDate.getMonth() + 1;
        month = month < 10 ? `0${month}` : month;
        if (`${year}${month}` !== idBirthday) {
          Toast.fail("所选出生年月与身份证号不符");
        }
      }
    };

    const selectFullTimeMajor = (key, value) => {
      state.fullTimeMajor = key;
      state.fullTimeMajorTxt = value;
    };

    const selectContinueMajor = (key, value) => {
      state.continueMajor = key;
      state.continueMajorTxt = value;
    };

    const validateSubjectCount = (val) => {
      // 8-4. 任教学科门数 (1:无, 2:1门, 3:2门, 4:3门, 5:4门, 6:5门及以上)
      if (state.subjectNum === 1) return true;
      const requiredCount = state.subjectNum - 1;
      if (requiredCount >= 5) {
        return val.length >= 5;
      }
      return val.length === requiredCount;
    };
    const validateRange6to100 = (val, rule) => {
      const num = Number(val);
      const sqNum = Number(state.squadronNum);
      if (!sqNum) return `请先填报中队数`;
      const label = rule.label || "";
      if (num < 2 * sqNum || num > 100 * sqNum)
        return `${label}数值需在${2 * sqNum}-${100 * sqNum}之间`;
      if (val.toString().includes(".")) return `${label}不能有小数`;
      return true;
    };
    const validateYoungPioneersNum = (val, rule) => {
      if (state.squadronNum === null || val === null || val === "") return true;
      const sqNum = Number(state.squadronNum);
      const num = Number(val);

      if (sqNum > 0) {
        const rangeCheck = validateRange6to100(val, rule);
        if (rangeCheck !== true) return rangeCheck;
        if (num <= sqNum) {
          return "少先队员人数必须大于中队数";
        }
      } else {
        if (num > 0 && num > 7) return "中队数为0时，少先队员人数要小于或等于7";
      }
      if (state.studentNum && num > Number(state.studentNum)) {
        return "少先队员人数不能超过本校学生数";
      }
      return true;
    };
    const validateSquadronNum = (val) => {
      if (val === null || val === undefined || val === "") return true;
      const num = Number(val);
      const rangeReg = /^[0-9]\d*$/;
      if (!rangeReg.test(val.toString())) {
        return "中队数必须为整数";
      }
      const ypNum = Number(state.youngPioneersNum);
      if (state.youngPioneersNum !== "" && state.youngPioneersNum !== null) {
        if (ypNum === 0 && num !== 0) {
          return "少先队员人数为0时，中队数量必须为0";
        }
        if (ypNum > 0 && num >= ypNum) {
          return "中队数必须小于少先队员人数";
        }
      }
      return true;
    };

    const validateStudentNum = (val, rule) => {
      if (!val) return true;
      const label = rule.label || "本校学生数";
      if (val.toString().includes(".")) return `${label}不能有小数`;
      const num = Number(val);
      if (state.youngPioneersNum && num < Number(state.youngPioneersNum)) {
        return `${label}不能少于少先队员人数`;
      }
      // 小学1到6年级：17100
      // 初中、完全中学7到9年级：13000
      // 九年一贯制、十二年一贯制1到9年级：20000
      const typeLimitMap = {
        1: 17100, // 小学
        2: 13000, // 初中
        5: 13000, // 完全中学
        3: 20000, // 九年一贯制
        4: 20000, // 十二年一贯制
      };
      // 获取当前学校类型对应的上限，若类型不在配置内，则给一个兜底值
      const currentLimit = typeLimitMap[state.schoolType] || 20000;
      if (num > currentLimit) {
        return `${label}超过当前学校类型限制，请再次核实`;
      }
      return true;
    };
    const validateMax200 = (val, rule) => {
      if (!val) return true;
      const label = rule.label || "";
      if (val.toString().includes(".")) return `${label}不能有小数`;
      const num = Number(val);
      if (num > 250) return `${label}不能超过250`;
      const sqNum = Number(state.squadronNum);
      if (sqNum === 0 && num > 0) {
        return `中队数量为0时，${label}必须为0`;
      }
      return true;
    };
    const validateMax20 = (val, rule) => {
      if (!val) return true;
      const label = rule.label || "";
      if (val.toString().includes(".")) return `${label}不能有小数`;
      const num = Number(val);
      if (num > 20) return `${label}不能超过20`;
      return true;
    };
    const validateWorkYears = (val, rule) => {
      if (val === "" || val === null || val === undefined) return true;
      const label = rule.label || "";
      const num = Number(val);
      if (num === 0) return `${label}不能填0`;
      if (!(Number.isInteger(num) || num % 1 === 0.5)) {
        return `${label}只能填整数或者X.5`;
      }
      if (state.age) {
        const maxYears = Number(state.age) - 16;
        if (num > maxYears) {
          // return `${label}不能超过 ${maxYears} 年（计算公式：年龄 - 16）`;
          return `${label}填写有误，请核实`;
        }
      }
      if (state.hasSquadronExp == 1 && state.squadronWorkYears) {
        if (num < Number(state.squadronWorkYears)) {
          return "累计从事少先队工作年限必须大于或等于担任中队辅导员累计年限";
        }
      }
      return true;
    };
    const validateSquadronWorkYears = (val, rule) => {
      if (val === "" || val === null || val === undefined) return true;
      const label = rule.label || "担任中队辅导员累计年限";
      const num = Number(val);
      if (num === 0) return `${label}不能填0`;
      if (!(Number.isInteger(num) || num % 1 === 0.5)) {
        return `${label}只能填整数或者X.5`;
      }
      if (state.workYears) {
        if (num > Number(state.workYears)) {
          return "担任中队辅导员累计年限不能超过累计从事少先队工作年限";
        }
      }
      return true;
    };
    const validateName = (val, rule) => {
      if (!val) return true;
      const label = rule.label || "姓名";
      // u 模式修饰符是必须的，用于启用 Unicode 支持
      // \p{Unified_Ideograph} 匹配所有汉字字符
      const nameReg =
        /^[\p{Unified_Ideograph}]+(?:·[\p{Unified_Ideograph}]+)*$/u;
      if (!nameReg.test(val)) {
        return `${label}只能输入汉字和间隔号“·”，且不能以“·”开始或结尾`;
      }
      if (val.length < 1 || val.length > 12) {
        return `${label}字数需在1到12个字之间`;
      }
      return true;
    };
    const validateWeeklyHours = (val) => {
      if (val === "" || val === null || val === undefined) return true;
      const num = Number(val);
      if (num === 0) {
        if (state.subjectNum !== 1) {
          return "只有选择“无教学任务”时，课时数才可以填写0";
        }
      } else {
        if (state.subjectNum === 1) {
          return "选择“无教学任务”时，课时数必须填写0";
        }
        if (num > 30) {
          return "每周课时数不能超过30";
        }
      }
      return true;
    };
    const handlePreview = (item) => {
      ImagePreview({
        images: [item.url || item.content],
        closeOnClickImage: true, // 明确开启此选项
        closeable: true, // 如果需要关闭图标
      });
    };
    const afterRead = async (file) => {
      file.status = "uploading";
      file.message = "上传中...";

      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("folder", "sxdsjtj");

      try {
        const response = await fetch("https://static.k618.cn/api/upload/", {
          method: "POST",
          body: formData,
        });
        const resData = await response.json();
        console.log("upload rest", resData);
        if (resData && resData.status == 0) {
          file.status = "done";
          file.url = resData.result[0].url;
          state.file = resData.result[0].url;
        } else {
          file.status = "failed";
          file.message = "上传失败";
          Toast.fail(resData.message || "上传失败");
        }
      } catch (error) {
        console.log("upload error ", error);
        file.status = "failed";
        file.message = "上传失败";
        Toast.fail("上传失败");
        console.error(error);
      }
    };

    const handleFailed = (errorInfo) => {
      console.log("failed", errorInfo);
      if (errorInfo && errorInfo.errors.length > 0) {
        tipsMsg("提示", errorInfo.errors[0].message, () => {
          // formRef.value.scrollToField(errorInfo.errors[0].name);
          console.log('errorInfo.errors[0].name', errorInfo.errors[0].name)
        });
      }
    };

    const onClickButtonSubmit = async () => {
      const { id, type } = route.query;
      if (isSubmitting.value) return; // 如果正在提交，直接拦截后续点击
      isSubmitting.value = true;

      // 手动校验 DatePicker 组件的必填字段
      // 当 personnelStatus == 1 时，任本校大队辅导员开始时间为必填
      if (state.personnelStatus == 1 && !state.startTime) {
        Toast.fail("请选择任本校大队辅导员开始时间");
        isSubmitting.value = false;
        return;
      }
      if (state.personnelStatus == 1 && !state.startTimeFlag) {
        state.startTimeFlag = true;
        Toast.fail("请选择任本校大队辅导员开始时间");
        isSubmitting.value = false;
        return;
      }

      const values = [
        { name: "schoolType", value: state.schoolType },
        { name: "schoolCode", value: state.schoolCode },
        { name: "location", value: state.location },
        { name: "squadronNum", value: state.squadronNum },
        { name: "youngPioneersNum", value: state.youngPioneersNum },
        { name: "studentNum", value: state.studentNum },
        { name: "congressType", value: state.congressType },
        { name: "lastCongressTime", value: state.lastCongressTime },
        { name: "batchEntry", value: state.batchEntry },
        { name: "hasRedScarfBadge", value: state.hasRedScarfBadge },
        { name: "hasRedScarfExplainer", value: state.hasRedScarfExplainer },
        { name: "hasYoungMilitarySchool", value: state.hasYoungMilitarySchool },
        { name: "isRedScarfDistributed", value: state.isRedScarfDistributed },
        { name: "hasYoungPioneersRoom", value: state.hasYoungPioneersRoom },
        { name: "roomSize", value: state.roomSize },
        { name: "hasDrumBugleCorps", value: state.hasDrumBugleCorps },
        { name: "corpsSize", value: state.corpsSize },
        { name: "activityClassSchedule", value: state.activityClassSchedule },
        { name: "offlineTrainingNum", value: state.offlineTrainingNum },
        { name: "directorPosition", value: state.directorPosition },
        { name: "directorName", value: state.directorName },
        {
          name: "directorPoliticalStatus",
          value: state.directorPoliticalStatus,
        },
        { name: "directorTel", value: state.directorTel },
        {
          name: "personnelStatus",
          value:
            state.personnelStatus == 2
              ? state.subPersonnelStatus
              : state.personnelStatus,
        },
        { name: "name", value: state.name },
        { name: "file", value: state.file },
        { name: "idCard", value: state.idCard },
        { name: "sex", value: state.sex },
        { name: "birthday", value: state.birthday },
        { name: "politicalStatus", value: state.politicalStatus },
        { name: "tel", value: state.tel },
        { name: "isNormalStudent", value: state.isNormalStudent },
        { name: "fullTimeEdu", value: state.fullTimeEdu },
        { name: "fullTimeMajor", value: state.fullTimeMajor },
        { name: "continueEdu", value: state.continueEdu },
        { name: "continueMajor", value: state.continueMajor },
        { name: "hasLeagueOrg", value: state.hasLeagueOrg },
        { name: "isLeagueCadre", value: state.isLeagueCadre },
        { name: "leaguePosition", value: state.leaguePosition },
        { name: "startTime", value: state.startTime },
        { name: "workYears", value: state.workYears },
        { name: "hasSquadronExp", value: state.hasSquadronExp },
        { name: "squadronWorkYears", value: state.squadronWorkYears },
        { name: "schoolPosition", value: state.schoolPosition },
        { name: "treatmentRank", value: state.treatmentRank },
        { name: "professionalTitle", value: state.professionalTitle },
        { name: "subjectNum", value: state.subjectNum },
        { name: "subjects", value: state.subjects.join(",") },
        { name: "subjectsOther", value: state.subjectsOther },
        { name: "weeklyHours", value: state.weeklyHours },
        { name: "deputyCounselorNum", value: state.deputyCounselorNum },
        { name: "fillerName", value: state.fillerName },
        { name: "fillerTel", value: state.fillerTel },
        { name: "fillerUnitJob", value: state.fillerUnitJob },
      ];

      Dialog.confirm({
        title: "提示",
        message: "你确定要提交吗？",
      })
        .then(async () => {

          const toast = Toast.loading({
            message: "提交中...",
            forbidClick: true, // 核心：禁止背景点击
            duration: 0,
          });

          let data = {
            formId: 41,
            list: values.map((item) => ({
              fieldCode: item.name,
              value: item.value,
            })),
          };
          if (type == 1) {
            data.id = id;
          }
          console.log("data -> ", data);
          let aesKey = getKey().toLowerCase();
          let param = {
            encryptData: encrypt(data, aesKey),
            encrypted: rsaUtil.encrypt(aesKey, serverPublicKey),
          };
          try {
            const res =
              type == 1 ? await editForm(param) : await addForm(param);
            if (res.code === 10000) {
              Toast.success("提交成功");
              goBack();
            }
          } catch (error) {
            console.error(error);
            // 只有失败时才解锁，让用户可以修正后重新提交
            isSubmitting.value = false;
          } finally {
            toast.clear();
            isSubmitting.value = false;
          }
        })
        .catch(() => {
          // 用户点了取消，确保锁是关着的
          isSubmitting.value = false;
        });
    };

    const getInfo = async (id) => {
      const res = await getsubmitData({ dataId: id });
      if (res.code === 10000 && res.data) {
        const data = res.data;
        state.id = data.id;
        data.list.forEach((item) => {
          const { fieldCode, value } = item;
          if (Object.prototype.hasOwnProperty.call(state, fieldCode)) {
            if (fieldCode === "subjects") {
              state.subjects = value ? value.split(",").map(Number) : [];
            } else if (fieldCode === "file") {
              state.file = value;
              if (value) {
                state.fileList = [{ url: value }];
              }
            } else if (fieldCode === "personnelStatus") {
              const val = Number(value);
              if (val === 2 || val === 3) {
                state.personnelStatus = 2;
                state.subPersonnelStatus = val;
              } else {
                state.personnelStatus = val;
              }
            } else if (fieldCode === "birthday") {
              state.birthday = value;
              state.age = value;
            } else {
              state[fieldCode] = value;
            }

            // 处理文本回显
            if (fieldCode === "fullTimeMajor") {
              const major = majorList.find((m) => m.key == value);
              if (major) state.fullTimeMajorTxt = major.value;
            }
            if (fieldCode === "continueMajor") {
              const major = majorList.find((m) => m.key == value);
              if (major) state.continueMajorTxt = major.value;
            }

            // 自动填充确认字段
            const confirmField = `${fieldCode}Confirm`;
            if (Object.prototype.hasOwnProperty.call(state, confirmField)) {
              state[confirmField] = value;
            }

            // 加入已确认集合，避免回显时触发弹窗
            state.confirmedFields.add(fieldCode);
          }
        });
      }
    };

    const goBack = () => {
      router.go(-1);
    };

    onMounted(async () => {
      const { id, type } = route.query;
      if (type == 1 && id) {
        getInfo(id);
      }
    });

    //监听中队数量，设置培训辅导员人数
    watch(
      () => state.squadronNum,
      (val) => {
        const num = Number(val);
        if (num === 0 && val !== "") {
          state.offlineTrainingNum = "0";
          state.offlineTrainingNumConfirm = "0";
        }
      }
    );

    //监听少先队员人数，设置中队数量
    watch(
      () => state.youngPioneersNum,
      (val) => {
        const num = Number(val);
        if (num === 0 && val !== "") {
          state.squadronNum = "0";
          state.squadronNumConfirm = "0";
        }
      }
    );

    //监听少工委主任职务，切换时清空对应内容
    watch(
      () => state.directorPosition,
      (val) => {
        if (val === 6) {
          state.directorName = "";
          state.directorNameConfirm = "";
          state.directorPoliticalStatus = null;
          state.directorTel = "";
          state.directorTelConfirm = "";
          state.confirmedFields.delete("directorName");
          state.confirmedFields.delete("directorTel");
        }
      }
    );

    // 监听字段变化，清空对应子项
    watch(
      () => state.idCard,
      (val) => {
        if (
          val &&
          /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
            val
          )
        ) {
          const birthYear = parseInt(val.substring(6, 10));
          const birthMonth = parseInt(val.substring(10, 12));
          const birthDay = parseInt(val.substring(12, 14));

          // 按照 2025 年 12 月 31 日结算年龄
          let ageValue = 2025 - birthYear;
          if (birthMonth > 12 || (birthMonth === 12 && birthDay > 31)) {
            ageValue--;
          }
          state.age = ageValue;
          state.birthday = ageValue; // 保持后端 birthday 字段同步

          // 自动回显性别
          const sexCode = val.substring(16, 17);
          state.sex = parseInt(sexCode) % 2 === 0 ? 2 : 1; // 2为女, 1为男
        }
      }
    );

    watch(
      () => state.congressType,
      (val) => {
        if (val != 1) {
          state.lastCongressTime = "";
        }
      }
    );

    watch(
      () => state.hasYoungPioneersRoom,
      (val) => {
        if (val != 1) {
          state.roomSize = null;
        }
      }
    );

    watch(
      () => state.hasDrumBugleCorps,
      (val) => {
        if (val != 1) {
          state.corpsSize = null;
        }
      }
    );

    watch(
      () => state.personnelStatus,
      (val) => {
        if (val == 2) {
          // 清空大队辅导员详细信息
          state.name = "";
          state.nameConfirm = "";
          state.fileList = [];
          state.file = "";
          state.idCard = "";
          state.idCardConfirm = "";
          state.sex = null;
          state.birthday = "";
          state.politicalStatus = null;
          state.tel = "";
          state.telConfirm = "";
          state.isNormalStudent = null;
          state.fullTimeEdu = null;
          state.fullTimeMajor = null;
          state.fullTimeMajorTxt = "";
          state.continueEdu = null;
          state.continueMajor = null;
          state.continueMajorTxt = "";
          state.startTime = "";
          state.workYears = "";
          state.workYearsConfirm = "";
          state.hasSquadronExp = null;
          state.squadronWorkYears = "";
          state.squadronWorkYearsConfirm = "";
          state.schoolPosition = null;
          state.treatmentRank = null;
          state.professionalTitle = null;
          state.subjectNum = null;
          state.subjects = [];
          state.subjectsOther = "";
          state.weeklyHours = "";
          state.weeklyHoursConfirm = "";
        } else {
          state.subPersonnelStatus = null;
        }
      }
    );

    watch(
      () => state.continueEdu,
      (val) => {
        if (val === 0 || val === null) {
          state.continueMajor = null;
          state.continueMajorTxt = "";
        }
      }
    );

    watch(
      () => state.hasLeagueOrg,
      (val) => {
        if (val != 1) {
          state.isLeagueCadre = null;
          state.leaguePosition = null;
        }
      }
    );

    watch(
      () => state.isLeagueCadre,
      (val) => {
        if (val != 1) {
          state.leaguePosition = null;
        }
      }
    );

    watch(
      () => state.hasSquadronExp,
      (val) => {
        if (val != 1) {
          state.squadronWorkYears = "";
          state.squadronWorkYearsConfirm = "";
        }
      }
    );

    watch(
      () => state.schoolPosition,
      (val) => {
        if (![4, 5, 6].includes(val)) {
          state.treatmentRank = null;
        }
      }
    );

    watch(
      () => state.subjectNum,
      (val) => {
        if (val <= 1) {
          state.subjects = [];
          state.subjectsOther = "";
        }
      }
    );

    watch(
      () => state.subjects,
      (val) => {
        if (!val.includes(10)) {
          state.subjectsOther = "";
        }
      },
      { deep: true }
    );

    return {
      ...toRefs(state),
      formRef,
      studentNumLabel,
      schoolTypeList,
      schoolAreaList,
      ruduiPiciList,
      sxdClassMList,
      sxdGhdPopList,
      sxdHdkList,
      sgwZhuRenList1,
      zzmmList02,
      eduList01,
      majorList,
      haveTuanJobMajorList,
      schoolMajorList,
      salaryList,
      jobTitleList,
      teachSubjectNumList,
      teachSubjectsList,
      handleDoubleCheck,
      handleCountCheck,
      handlerSelect,
      selectFullTimeMajor,
      selectContinueMajor,
      validateSubjectCount,
      validateRange6to100,
      validateSquadronNum,
      validateYoungPioneersNum,
      validateStudentNum,
      validateMax200,
      validateMax20,
      validateWorkYears,
      validateSquadronWorkYears,
      validateName,
      validateWeeklyHours,
      afterRead,
      handlePreview,
      handleFailed,
      onClickButtonSubmit,
      goBack,
    };
  },
};
</script>

<style scoped lang="less">
.go_back {
  height: 0.383rem;
  padding: 0.033rem 0 0 0.333rem;
  overflow: visible;
  color: rgb(255, 255, 255);
  font-size: 28px;
  z-index: 99;
}
.custom-cell-title {
  font-weight: bold;
  font-size: 16px;
}
:deep(.van-field__control--custom) {
  display: block;
}
.radioFlex :deep(.van-field__control--custom) {
  display: flex;
}
:deep(.van-cell__value),
:deep(.van-field__control),
:deep(.van-cell__right-icon) {
  color: #ff6865;
}
:deep(.van-radio--vertical),
:deep(.van-checkbox) {
  margin-bottom: 0.08rem !important;
}
:deep(.van-radio__icon .van-icon),
:deep(.van-checkbox__icon .van-icon) {
  border: 0.02667rem solid #ff6865 !important;
}
:deep(.van-cell__title) {
  color: #646566;
}
:deep(.van-radio-group) {
  padding: 0.168rem 0;
}
.title {
  text-align: center;
  font-size: 17px;
  margin-top: 10px;
  .tip {
    font-size: 12px;
  }
}
.fieldVertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.fieldVertical :deep(.van-cell__value),
.fieldVertical :deep(.van-field__control) {
  width: 100%;
}
.fieldVertical :deep(.van-cell__title) {
  width: 100%;
  flex: none;
  margin-bottom: 4px;
  white-space: normal;
}
.section-title {
  padding: 15px;
  font-weight: bold;
  font-size: 16px;
  color: #333;
  background: #fdfdfd;
  border-bottom: 1px solid #eee;
}
.section-title-1 {
  padding: 15px 17px;
  color: #646566;
  font-size: 14px;
  background: #fdfdfd;
  border-bottom: 1px solid #eee;
}
.tip-text {
  font-size: 12px;
  color: #999;
  padding: 0 16px 10px;
}

.official-document {
  // font-family: "FangSong", "仿宋", serif; /* 公文标准字体 */
  line-height: 1.5; /* 行间距 */
  text-align: justify; /* 两端对齐，使排版更整齐 */
  max-width: 800px; /* 根据实际页面需求调整宽度 */
  padding: 15px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  margin: 10px;
  border-radius: 4px;
  font-size: 16px;
}

.official-heading {
  font-weight: bold;
  margin-bottom: 10px;
  color: #faad14;
  text-indent: 2em;
}

.official-paragraph {
  text-indent: 2em; /* 核心：首行缩进2字符 */
  margin-top: 10px; /* 段落间距 */
  font-size: 16px;
}
.biaoshima {
  font-size: 16px;
  padding: 0 16px 10px;
}
</style>
